var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.23,
    height: 36.984,
    viewBox: "0 0 46.23 36.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-photo-video",
    "data-name": "Icon awesome-photo-video",
    d: "M43.919,0H11.558A2.312,2.312,0,0,0,9.246,2.312V9.246H20.8V4.623H34.673V27.738h9.246a2.312,2.312,0,0,0,2.312-2.312V2.312A2.312,2.312,0,0,0,43.919,0ZM16.759,7.44a.65.65,0,0,1-.65.65H13.941a.65.65,0,0,1-.65-.65V5.273a.65.65,0,0,1,.65-.65h2.167a.65.65,0,0,1,.65.65ZM42.185,22.465a.65.65,0,0,1-.65.65H39.368a.65.65,0,0,1-.65-.65V20.3a.65.65,0,0,1,.65-.65h2.167a.65.65,0,0,1,.65.65Zm0-7.512a.65.65,0,0,1-.65.65H39.368a.65.65,0,0,1-.65-.65V12.786a.65.65,0,0,1,.65-.65h2.167a.65.65,0,0,1,.65.65Zm0-7.512a.65.65,0,0,1-.65.65H39.368a.65.65,0,0,1-.65-.65V5.273a.65.65,0,0,1,.65-.65h2.167a.65.65,0,0,1,.65.65ZM30.05,11.558H2.312A2.312,2.312,0,0,0,0,13.869v20.8a2.312,2.312,0,0,0,2.312,2.312H30.05a2.312,2.312,0,0,0,2.312-2.312v-20.8A2.312,2.312,0,0,0,30.05,11.558ZM6.935,16.181a2.312,2.312,0,1,1-2.312,2.312,2.312,2.312,0,0,1,2.312-2.312Zm20.8,16.181H4.623V30.05l4.623-4.623,2.312,2.312L20.8,18.492l6.935,6.935Z",
    fill: "#605858"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoVideo);
export default __webpack_public_path__ + "static/media/photo_video.da658202b17feca3caf585a5c9704d60.svg";
export { ForwardRef as ReactComponent };